import {
    ForgotPassword,
    ForgotPasswordError,
    ForgotPasswordOptionsAction,
    FORGOT_PASSWORD,
    FORGOT_PASSWORD_ERROR,
    FORGOT_PASSWORD_SUCCESS,
    FORGOT_PASSWORD_INITIAL,
} from '../_types/forgotPassword';

export const setForgotPasswordLoading = (): ForgotPasswordOptionsAction => {
    return {
        type: FORGOT_PASSWORD,
    };
};

export const setForgotPasswordInitial = (): ForgotPasswordOptionsAction => {
    return {
        type: FORGOT_PASSWORD_INITIAL,
    };
};

export const setForgotPasswordError = (err: ForgotPasswordError): ForgotPasswordOptionsAction => {
    return {
        type: FORGOT_PASSWORD_ERROR,
        payload: err,
    };
};

export const setForgotPasswordSuccess = (data: Array<ForgotPassword>): ForgotPasswordOptionsAction => {
    return {
        type: FORGOT_PASSWORD_SUCCESS,
        payload: data,
    };
};
